interface ContructorParams {
	objectiveAmount?: number
	rewardAmount?: number
	objectiveExpirationDays?: number
}

export class MicrositeObjective {
	public objectiveAmount?: number
	public rewardAmount?: number
	public objectiveExpirationDays?: number

	constructor(params: ContructorParams) {
		this.objectiveAmount = params.objectiveAmount
		this.rewardAmount = params.rewardAmount
		this.objectiveExpirationDays = params.objectiveExpirationDays
	}
}
